export type SitesProps = {
  type?: 'customer' | 'organization' | 'recycle';
};

export enum BoundaryTypeEnum {
  'center' = 'Center',
  'geofence' = 'Geofence',
}
